import { useRef, useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import {
  CircleQuestionRegularV6,
  FolderClosedRegularV6,
  GraduationCapRegularV6,
  MessageSmileRegularV6,
} from "@shared/v2/Icomoon";
import { useClickOutside } from "@shared/hookHelpers";
import Popover from "../../Popover";

const HelpLink = ({ href = undefined, icon, label, onClick, ...other }) => {
  const Element = href ? "a" : "button";
  const props = href
    ? { href, target: "_blank", rel: "noopener noreferrer", ...other }
    : { type: "button", ...other };

  return (
    <Element
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className="tw-flex tw-items-center tw-gap-[8px] tw-px-[12px] tw-py-[8px] tw-rounded-[8px] tw-border-none tw-bg-white hover:tw-bg-gray-5 hover:tw-no-underline tw-text-left tw-text-gray-75 hover:tw-text-gray-99"
      onClick={onClick}
    >
      {icon}
      <span className="tw-flex-1 tw-text-14d tw-font-semibold">{label}</span>
    </Element>
  );
};

HelpLink.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const HelpPopover = () => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  useClickOutside(ref, close);

  return (
    <div ref={ref} className="tw-relative">
      <IconButton
        schema="transparent"
        id="dayInTheLifeHelp"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <CircleQuestionRegularV6 />
      </IconButton>
      <Popover
        aria-labelledby="dayInTheLifeHelp"
        className="tw-w-[318px] tw-z-3000 tw-p-[24px] tw-flex tw-flex-col tw-gap-[16px] tw-border-solid tw-border-[1px] tw-border-gray-10"
        open={open}
      >
        <h2 className="tw-text-18d tw-font-bold tw-text-gray-75 tw-m-0 tw-flex tw-items-center tw-gap-[4px]">
          <CircleQuestionRegularV6 size="xl" /> How to use Day in the Life
        </h2>
        <div className="tw-flex tw-flex-col tw-gap-[2px]">
          <HelpLink
            icon={<GraduationCapRegularV6 size="l" />}
            label="Mastering a Day in the Life"
            onClick={close}
          />
          <HelpLink icon={<FolderClosedRegularV6 size="l" />} label="Scripts and resources" onClick={close} />
          <hr className="tw-w-full tw-my-[8px] tw-border-solid tw-border-t-[1px] tw-border-x-0 tw-border-b-0 tw-border-gray-10" />
          <HelpLink
            icon={<MessageSmileRegularV6 size="l" />}
            id="intercom-give-feedback"
            label="Give Feedback"
            onClick={close}
          />
        </div>
      </Popover>
    </div>
  );
};

export default HelpPopover;
